module.exports = __webpack_public_path__ + "static/sport/swiper-5.ad5a213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/swiper-5.png
// module id = BtTf
// module chunks = 0